import { useAppContext } from '@/components/AppContext'
import DragAndDropModal from '@/hoc/DragAndDropModal'
import { A4B_APPS } from '@/utils/constants'
import { Spin, message } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import { sortBy, isEqual } from 'lodash'
import React, { useCallback, useEffect, useState } from 'react'
import PageInfoForm from '../../components/pages/PageInfoForm'
import ManagePagesPage from '../../components/pages/ManagePages'
import {
  ManageSectionItem,
  PageListItem,
} from '@a4b/api/src/modules/Monetisation/Offerings/types'
import { formatPageinfoByPageType } from '../../utils/pages-helper'
import { sectionPageKeys } from '../../utils/constants'
import { LoadingOutlined } from '@ant-design/icons'
import SectionInfo from './SectionInfo'
import SectionInfoShort from './SectionInfoShort'
import { getMonetisationPujaApi, showErrorToast } from '@/utils/helper'

const ManagePagesScreen: React.FC = () => {
  const { networkInstance, languageState, app } = useAppContext()
  const isSrimandir = app === A4B_APPS.SRIMANDIR
  const monetisationPujaApi = getMonetisationPujaApi(app, networkInstance)
  const [pageForm] = useForm()
  const [feedsForm] = useForm()
  const [showPageForm, setShowPageForm] = React.useState(false)
  const [showUpdateButton, setShowUpdateButton] = React.useState(false)
  const [currentPageTypeData, setCurrentPageTypeData] = React.useState<
    PageListItem | undefined
  >()
  const [pageInfoList, setPageInfoList] = React.useState<PageListItem[]>([])
  const [showDandDModal, setDandDModalVisibility] = useState(false)

  const [sortedSectionList, setSortedSectionList] = useState<
    ManageSectionItem[]
  >([])

  const [sectionList, setSectionList] = useState<ManageSectionItem[]>([])
  const [isLoading, setIsLoading] = React.useState(false)

  const getSections = useCallback(
    async (pageList: any, currentPageData: PageListItem | undefined) => {
      setShowUpdateButton(false)
      try {
        const sections = await monetisationPujaApi.storesApi.getSections({
          limit: 1000,
          offset: 0,
        })
        setSectionList(sections?.data?.data?.sections)
        if (pageList.length) {
          const feedPage = pageList?.find(
            (item: PageListItem) =>
              (item.key === currentPageData?.key) && (item.language_code === currentPageData?.language_code),
          )
          const filteredSection = sections?.data?.data?.sections?.filter(
            (section: ManageSectionItem) =>
              feedPage?.sections?.includes(section.id),
          )
          const sortedItems = sortBy(filteredSection, (item: ManageSectionItem) => feedPage?.sections?.indexOf(item?.id))
          if (sortedItems?.length) {
            setSortedSectionList(sortedItems)
          } else {
            setSortedSectionList([])
          }
        }
      } catch (error) {
        showErrorToast(error)
        // message.error({
        //   content: 'Error while fetching sections',
        //   duration: 3,
        // })
        console.log(error)
      }
    },
    [monetisationPujaApi.storesApi],
  )

  const getFaqsForPage = useCallback(
    async (currentPageType: string) => {
      try {
        const faqList = await monetisationPujaApi.faqsApi?.getFaqs({
          faq_type: currentPageType,
        })

        pageForm.setFieldsValue({ faqs: faqList?.data?.data })
        setShowPageForm(true)
      } catch (error) {
        message.error({
          content: `Error while fetching Faq's for page ${currentPageType}`,
          duration: 3,
        })
        console.log(error)
      }
    },
    [monetisationPujaApi.faqsApi],
  )
  const getReviewsForPage = useCallback(
    async (currentPageTypeData: any) => {
      if (
        currentPageTypeData?.key !== 'offerings_feed_page' &&
        currentPageTypeData?.key !== 'offerings_feed_page_with_pooja' &&
        currentPageTypeData?.key !== 'store_list_page_pooja'
      ) {
        return
      }
      try {
        const reviews = await monetisationPujaApi.reviewApi?.getReviews(
          currentPageTypeData?.id || '',
        )
        feedsForm.setFieldsValue({
          reviews: reviews?.data?.data?.length
            ? reviews?.data?.data?.map((item: any) => ({
              ...item,
              user_image_url: [item.user_image_url],
            }))
            : [{}],
        })
        pageForm.setFieldsValue({
          reviews: reviews?.data?.data?.length
            ? reviews?.data?.data?.map((item: any) => ({
              ...item,
              user_image_url: [item.user_image_url],
            }))
            : [{}],
        })
      } catch (error) {
        message.error({
          content: `Error while fetching review for page ${currentPageTypeData?.key}`,
          duration: 3,
        })
        console.log(error)
      }
    },
    [monetisationPujaApi.reviewApi],
  )

  const getTutorialsForPage = useCallback(
    async (currentPageType: string) => {
      try {
        const tutorials = await monetisationPujaApi.tutorialApi?.getTutorials({
          tutorial_type: currentPageType,
        })

        if (
          currentPageType !== 'offerings_feed_page' &&
          currentPageType !== 'offerings_feed_page_with_pooja'
        ) {
          pageForm.setFieldsValue({
            tutorials: tutorials?.data
              ? {
                ...tutorials?.data?.data,
                media_url: [tutorials?.data?.data?.media?.media_url],
              }
              : {},
          })
          setShowPageForm(true)
        } else {
          const help_tutorials =
            await monetisationPujaApi.tutorialApi?.getTutorials({
              tutorial_type: 'offerings_feed_help_tutorial_page',
            })
          feedsForm.setFieldsValue({
            tutorials: {
              ...tutorials?.data?.data,
              media_url: [tutorials?.data?.data?.media?.media_url],
            },
            help_tutorials: {
              ...help_tutorials?.data?.data,
              media_url: [help_tutorials?.data?.data?.media?.media_url],
            },
          })
        }
      } catch (error) {
        message.error({
          content: `Error while fetching Faq's for page ${currentPageType}`,
          duration: 3,
        })
        console.log(error)
      }
    },
    [monetisationPujaApi.tutorialApi],
  )

  const getStepsForPage = useCallback(
    async (currentPageType: string) => {
      try {
        const steps = await monetisationPujaApi.stepsApi?.getSteps(currentPageType)
        pageForm.setFieldsValue({ steps: steps?.data?.data })
        setShowPageForm(true)
      } catch (error) {
        message.error({
          content: `Error while fetching Steps's for page ${currentPageType}`,
          duration: 3,
        })
        console.log(error)
      }
    },
    [monetisationPujaApi.stepsApi, pageForm],
  )

  const getPageInfoList = useCallback(async () => {
    try {
      setIsLoading(true)
      const pageInfoList = await monetisationPujaApi.pageInfoApi.getPageInfoList()
      if (isSrimandir) {
        setPageInfoList(pageInfoList?.data?.data?.pages)
      } else {
        setPageInfoList(pageInfoList?.data?.data?.pages?.filter((page) => page?.key?.startsWith('remedy_')))
      }
      const feedPage = pageInfoList?.data?.data?.pages?.find(
        (item: PageListItem) => item.key === 'offerings_feed_page',
      )

      if (sectionList?.length) {
        const filteredSection = sectionList?.filter(
          (section: ManageSectionItem) =>
            feedPage?.sections?.includes(section.id),
        )

        if (filteredSection?.length) {
          setSortedSectionList(filteredSection)
        }
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      message.error({
        content: 'Error while fetching page info list',
        duration: 3,
      })
      console.log(error)
    }
  }, [])

  useEffect(() => {
    getPageInfoList()
  }, [getPageInfoList])

  const closePageForm = () => {
    setShowPageForm(false)
  }

  const handleCreateApiCalls = async (formData: any) => {
    console.log(currentPageTypeData?.key, 'switch key')
    switch (currentPageTypeData?.key) {
      case 'store_list_page_pooja':
        try {
          if (formData?.faqs?.create?.faqs?.length) {
            await monetisationPujaApi.faqsApi.createFaqs({
              ...formData?.faqs?.create,
              language_code: languageState?.monetisationLanguage,
            })
          }
          if (formData?.faqs?.update?.faqs?.length) {
            await monetisationPujaApi.faqsApi.updateFaqs({
              ...formData?.faqs?.update,
              language_code: languageState?.monetisationLanguage,
            })
          }
          if (formData?.reviews?.create?.reviews?.length) {
            try {
              await monetisationPujaApi.reviewApi.createReviews(
                formData?.reviews?.create,
              )
              message.success({
                content: 'Reviews Created Successfully',
                duration: 2,
                key: 'review_create',
              })
            } catch (error) {
              console.log('error occured while creating faq', error)
              message.error({
                content: 'Error occured while creating faqs and reviews',
                duration: 2,
                key: 'review_create',
              })
            }
          }
          if (formData?.reviews?.update?.reviews?.length) {
            try {
              await monetisationPujaApi.reviewApi.updateReviews(
                formData?.reviews?.update,
              )
              message.success({
                content: 'Reviews Updated Successfully',
                duration: 2,
                key: 'review_update',
              })
            } catch (error) {
              console.log('error occured while updating faq', error)
              message.destroy('review_update')
            }
          }

          const payload = sortedSectionList?.map((item: any) => item?.id)
          try {
            await monetisationPujaApi?.pageInfoApi?.updatePages(
              currentPageTypeData?.id || '',
              {
                sections: payload,
              },
            )
            message.success({ content: 'Section updated sucessfully', duration: 3 })
            getPageInfoList()

          } catch (error) {
            message.error({ content: 'Error occured while updating pages.' })
          }

          message.success({
            content: 'Faqs and Reviews submitted successfully',
            duration: 3,
          })
          pageForm.resetFields()
          setCurrentPageTypeData(undefined)
          setShowPageForm(false)
        }
        catch (error) {
          message.error({
            content: 'Faqs and Reviews failed while submission',
            duration: 2,
          })
          console.log(error)
        }
        return

      case 'store_list_page':
        message.loading({
          content: 'Creating faqs and tutorials...',
          duration: 1,
        })
        try {
          if (formData?.faqs?.create?.faqs?.length) {
            await monetisationPujaApi.faqsApi.createFaqs({
              ...formData?.faqs?.create,
              language_code: languageState?.monetisationLanguage,
            })
          }
          if (formData?.faqs?.update?.faqs?.length) {
            await monetisationPujaApi.faqsApi.updateFaqs({
              ...formData?.faqs?.update,
              language_code: languageState?.monetisationLanguage,
            })
          }
          if (formData?.tutorials && formData?.tutorials.create) {
            await monetisationPujaApi.tutorialApi.createTutorials({
              ...formData?.tutorials?.create,
              language_code: languageState?.monetisationLanguage,
            })
          }
          if (formData?.tutorials && formData?.tutorials.update) {
            await monetisationPujaApi.tutorialApi.updateTutorials({
              ...formData?.tutorials?.update,
              language_code: languageState?.monetisationLanguage,
            })
          }
          message.success({
            content: 'Faqs and tutorials submitted successfully',
            duration: 3,
          })
          pageForm.resetFields()
          setCurrentPageTypeData(undefined)
          setShowPageForm(false)
        } catch (error) {
          message.error({
            content: 'Faqs and tutorials failed while submission',
            duration: 2,
          })
          console.log(error)
        }
        return
      case 'cart_review_page':
      case 'cart_review_page_pooja':
        message.loading({
          content: 'Creating faqs...',
          duration: 1,
        })
        try {
          if (formData?.faqs?.create?.faqs?.length) {
            await monetisationPujaApi.faqsApi.createFaqs({
              ...formData?.faqs?.create,
              language_code: languageState?.monetisationLanguage,
            })
          }
          if (formData?.faqs?.update?.faqs?.length) {
            await monetisationPujaApi.faqsApi.updateFaqs({
              ...formData?.faqs?.update,
              language_code: languageState?.monetisationLanguage,
            })
          }
          message.success({
            content: 'Faqs created successfully',
            duration: 3,
          })
          pageForm.resetFields()
          setCurrentPageTypeData(undefined)
          setShowPageForm(false)
        } catch (error) {
          message.error({
            content: 'Faqs creation failed',
            duration: 2,
          })
          console.log(error)
        }
        return
      case 'payment_successful_page_pooja':
      case 'payment_successful_page':
      case 'payment_failed_page':
        message.loading({
          content: 'Creating steps...',
          duration: 1,
        })

        if (formData?.steps?.update?.steps?.length) {
          try {
            await monetisationPujaApi.stepsApi.updateSteps({
              ...formData?.steps?.update,
              language_code: languageState?.monetisationLanguage,
            })

            message.success({
              content: 'Steps updated successfully',
              duration: 3,
            })
          } catch (error) {
            message.error({
              content: 'Steps creation failed',
              duration: 2,
            })
            console.log(error)
          }
        }
        if (formData?.steps?.create?.steps?.length) {
          try {
            await monetisationPujaApi.stepsApi.createSteps({
              ...formData?.steps?.create,
              language_code: languageState?.monetisationLanguage,
            })

            message.success({
              content: 'Steps created successfully',
              duration: 3,
            })
          } catch (error) {
            message.error({
              content: 'Steps creation failed',
              duration: 2,
            })
            console.log(error)
          }
        }
        pageForm.resetFields()
        setCurrentPageTypeData(undefined)
        setShowPageForm(false)
        return
      case 'order_fulfilment_generic_faq':
      case 'remedy_cart_review_page_faq':
      case 'remedy_order_fulfilment_faq':
        try {
          if (formData?.faqs?.create?.faqs?.length) {
            await monetisationPujaApi.faqsApi.createFaqs({
              ...formData?.faqs?.create,
              language_code: languageState?.monetisationLanguage,
            })
          }
          if (formData?.faqs?.update?.faqs?.length) {
            await monetisationPujaApi.faqsApi.updateFaqs({
              ...formData?.faqs?.update,
              language_code: languageState?.monetisationLanguage,
            })
          }
          message.success({ content: 'FAQ updated succesfully' })
        } catch (error) {
          message.error({ content: 'Error occured while updating pages.' })
        }
        pageForm.resetFields()
        setCurrentPageTypeData(undefined)
        setShowPageForm(false)
        return
      default:
        const payload = sortedSectionList?.map((item: any) => item?.id)
        try {
          await monetisationPujaApi?.pageInfoApi?.updatePages(
            currentPageTypeData?.id || '',
            {
              sections: payload,
            },
          )
          message.success({ content: 'Section updated sucessfully', duration: 3 })
          getPageInfoList()

        } catch (error) {
          message.error({ content: 'Error occured while updating pages.' })
        }
        message.success({
          content: 'Update sections banner items',
          duration: 3,
        })
        pageForm.resetFields()
        setCurrentPageTypeData(undefined)
        setShowPageForm(false)
    }
  }

  const formSubmithandler = (sections: any) => {
    pageForm
      .validateFields()
      .then(values => {
        if (currentPageTypeData) {
          const formData = formatPageinfoByPageType(
            currentPageTypeData,
            { ...pageForm.getFieldsValue(), sections },
            languageState?.monetisationLanguage
          )
          console.log({ formData })
          handleCreateApiCalls(formData)
        }
      })
      .catch(error => {
        console.log('Validation error', error, pageForm.getFieldsError())
      })
  }
  const onClickHandler = (pageType: string, language_code: string) => {
    const filteredPageType = pageInfoList.find(item => item.key === pageType && item.language_code === language_code)
    setCurrentPageTypeData(filteredPageType)
    if (
      pageType === 'offerings_feed_page' ||
      pageType === 'offerings_feed_page_with_pooja'
    ) {
      return
    } else {
      if (filteredPageType?.key === 'store_list_page') {
        getFaqsForPage(filteredPageType?.key || '')
        getTutorialsForPage(filteredPageType?.key || '')
      }
      if (
        filteredPageType?.key === 'cart_review_page' ||
        filteredPageType?.key === 'cart_review_page_pooja' ||
        filteredPageType?.key === 'order_fulfilment_generic_faq' ||
        filteredPageType?.key === 'remedy_cart_review_page_faq' ||
        filteredPageType?.key === 'remedy_order_fulfilment_faq'
      ) {
        getFaqsForPage(filteredPageType?.key || '')
      }
      if (
        filteredPageType?.key === 'payment_successful_page' ||
        filteredPageType?.key === 'payment_successful_page_pooja' ||
        filteredPageType?.key === 'payment_failed_page'
      ) {
        getStepsForPage(filteredPageType?.key || '')
      }
      if (filteredPageType?.key === 'store_list_page_pooja' || filteredPageType?.key?.endsWith('_campaign')) {
        getReviewsForPage(filteredPageType)
        getFaqsForPage(filteredPageType?.key || '')
        getSections(pageInfoList, filteredPageType)
      }
      if (sectionPageKeys.includes(filteredPageType?.key!)
      ) {
        getSections(pageInfoList, filteredPageType)
        setShowPageForm(true)
      }
    }
  }

  const handleOnCancel = () => {
    setDandDModalVisibility(false)
  }

  const handleOnOk = (sortedList: any[]) => {
    setSortedSectionList(sortedList)
    const sortedIds = sortedList?.map((item: any) => item?.id)
    if (!isEqual(currentPageTypeData?.sections, sortedIds)) {
      setShowUpdateButton(true)
    } else {
      setShowUpdateButton(true)
    }
    setDandDModalVisibility(false)
  }

  const deleteFaq = async (id: string, callback: any) => {
    try {
      await monetisationPujaApi.faqsApi.deleteFaq(id)
      message.success({
        content: 'Faq deleted successfully',
        duration: 3,
      })
      callback()
      getFaqsForPage(currentPageTypeData?.key || '')
    } catch (error) {
      message.error({
        content: 'Faq deletion failed',
        duration: 2,
      })
      getFaqsForPage(currentPageTypeData?.key || '')
      console.log(error)
    }
  }
  const deleteSteps = async (id: string, callback: any) => {
    try {
      await monetisationPujaApi.stepsApi.deleteStep(id)
      message.success({
        content: 'Step deleted successfully',
        duration: 3,
      })
      callback()
      getStepsForPage(currentPageTypeData?.key || '')
    } catch (error) {
      message.error({
        content: 'Step deletion failed',
        duration: 2,
      })
      getStepsForPage(currentPageTypeData?.key || '')
      console.log(error)
    }
  }
  const deleteReview = async (id: string, callback: any) => {
    try {
      await monetisationPujaApi.reviewApi.deleteReview(id)
      message.success({
        content: 'Review deleted successfully',
        duration: 3,
      })
      callback()
      getReviewsForPage(currentPageTypeData)
    } catch (error) {
      message.error({
        content: 'Review deletion failed',
        duration: 2,
      })
    }
  }
  const deleteTutorial = async (id: string) => {
    try {
      await monetisationPujaApi.tutorialApi.deleteTutorials(id)
      message.success({
        content: 'tutorial deleted successfully',
        duration: 3,
      })
      feedsForm.resetFields()
      getTutorialsForPage(currentPageTypeData?.key || '')
      getReviewsForPage(currentPageTypeData)
    } catch (error) {
      message.error({
        content: 'Faq deletion failed',
        duration: 2,
      })
      getTutorialsForPage(currentPageTypeData?.key || '')
      console.log(error)
    }
  }
  const formChangeHandler = (values: any) => {
    setShowUpdateButton(true)
  }
  return (
    <div style={{ padding: '0 40px' }}>
      {
        isLoading ?
          <div style={{ minHeight: '50vh', display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
            <Spin indicator={<LoadingOutlined style={{ fontSize: 32 }} spin />} />
          </div>
          :
          <>
            <ManagePagesPage
              dataSource={pageInfoList}
              onClickhandler={onClickHandler}
            />
            {showPageForm &&
              <PageInfoForm
                form={pageForm}
                formSubmithandler={formSubmithandler}
                onClose={closePageForm}
                visible={showPageForm}
                pageTitle={currentPageTypeData?.name || ''}
                currentPageTypeData={currentPageTypeData}
                deleteFaq={deleteFaq}
                deleteTutorials={deleteTutorial}
                deleteSteps={deleteSteps}
                deleteReview={deleteReview}
                setDandDModalVisibility={setDandDModalVisibility}
                sortedSectionList={sortedSectionList}
                showUpdateButton={showUpdateButton}
                renderer={<SectionInfo />}
                formChangeHandler={formChangeHandler}
              />
            }
            <DragAndDropModal
              showModal={showDandDModal}
              handleOnCancel={handleOnCancel}
              handleOnOk={handleOnOk}
              sortedData={sortedSectionList}
              itemList={sectionList}
              title={`Select and arrange sections`}
            >
              <SectionInfoShort key={'section-rendered'} />
            </DragAndDropModal>
          </>
      }
    </div>
  )
}

export default ManagePagesScreen
